import { Box } from '@mui/material'
import NotifBox from 'components/plan/NotifBox'

import PageContainer from 'layouts/PageContainer'
import { useState } from 'react'
import { FormProvider, useWatch } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { COLORS } from 'styles/colors'
import { ButtonUI } from 'ui/buttons/ButtonUI'
import ExitWarningModal from 'ui/modal/ExitWarningModal'
import Preloader from 'ui/Preloader'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import ShiftCard from './components/ShiftCard'
import { useMilkingScheduleMutation } from './hooks/useMilkingScheduleMutation'
import { useMilkingSettingsForm } from './hooks/useMilkingSettingsForm'
import { IMilkingFieldForm } from './types/milkingForm'

const MilkingSchedulesPage = () => {
	const [exitDialogOpen, setExitDialogOpen] = useState<boolean>(false)
	const navigate = useNavigate()
	const { form, isLoading } = useMilkingSettingsForm()
	const { mutate: updateMilkingSchedule, isPending } =
		useMilkingScheduleMutation()
	const {
		formState: { isValid, isDirty, isSubmitting },
	} = form

	const fields: IMilkingFieldForm[] = [
		{
			id: 'am',
			label: 'Утренняя дойка',
			halls: useWatch({ control: form.control, name: 'am.halls' }),
			deviation: 'am_allowed_deviation_seconds',
		},
		{
			id: 'pm',
			label: 'Дневная дойка',
			halls: useWatch({ control: form.control, name: 'pm.halls' }),
			deviation: 'pm_allowed_deviation_seconds',
		},
		{
			id: 'night',
			label: 'Ночная дойка',
			halls: useWatch({ control: form.control, name: 'night.halls' }),
			deviation: 'night_allowed_deviation_seconds',
		},
	]

	if (isLoading) {
		return <Preloader mt={15} />
	}

	return (
		<PageContainer>
			<FormProvider {...form}>
				<form onSubmit={form.handleSubmit(data => updateMilkingSchedule(data))}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: '24px',
							height: '100%',
							backgroundColor: COLORS.background,
						}}
					>
						<NotifBox />

						<Box display='flex' flexDirection='column' gap='24px'>
							{fields.map(field => (
								<ShiftCard key={field.id} shiftInfo={field} />
							))}
						</Box>

						<Box
							display='flex'
							justifyContent='flex-end'
							alignItems='center'
							gap='24px'
						>
							<TypographySecondary
								sx={{ cursor: 'pointer', textWrap: 'nowrap' }}
								onClick={() => {
									isDirty ? setExitDialogOpen(true) : navigate(-1)
								}}
							>
								Отменить
							</TypographySecondary>

							<ButtonUI type='submit' disabled={!isDirty || !isValid}>
								{isPending || isSubmitting ? (
									<Preloader color='#fff' />
								) : (
									'Сохранить'
								)}
							</ButtonUI>
						</Box>
					</Box>

					<ExitWarningModal
						open={exitDialogOpen}
						onClose={() => setExitDialogOpen(false)}
						onSave={() => setExitDialogOpen(false)}
						onDismiss={() => {
							setExitDialogOpen(false)
							navigate(-1)
						}}
						title={'Выйти без сохранения'}
						description={'Внесенные изменения будут утеряны.'}
						onSaveText={'Вернуться к редактированию'}
						onDismissText={'Выйти без сохранения'}
					/>
				</form>
			</FormProvider>
		</PageContainer>
	)
}

export default MilkingSchedulesPage
